import { __assign } from "tslib";
import React from 'react';
import { Text, Badge } from '@keen.io/ui-core';
import { Container, Heading, Header, TagContainer, } from './widget-heading.styles';
var Title = function (_a) {
    var content = _a.content, typography = _a.typography;
    return (React.createElement(Heading, null,
        React.createElement(Text, __assign({}, typography), content)));
};
var Tags = function (_a) {
    var tags = _a.tags, marginTop = _a.marginTop, marginLeft = _a.marginLeft;
    return (React.createElement(TagContainer, { marginTop: marginTop, marginLeft: marginLeft, "data-testid": "widget-tags" }, tags.map(function (_a) {
        var label = _a.label, variant = _a.variant;
        return (React.createElement(Badge, { key: label, variant: variant }, label));
    })));
};
export var WidgetHeading = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, tags = _a.tags;
    return (React.createElement(Container, { "data-testid": "widget-heading" },
        (title === null || title === void 0 ? void 0 : title.content) && (React.createElement(Header, null,
            React.createElement(Title, __assign({}, title, { "data-testid": "widget-title" })),
            ' ',
            tags && tags.length > 0 && (React.createElement(Tags, { tags: tags, marginTop: 5, marginLeft: 5 })))),
        (subtitle === null || subtitle === void 0 ? void 0 : subtitle.content) && (React.createElement(Header, null,
            React.createElement(Title, __assign({}, subtitle, { "data-testid": "widget-subtitle" })),
            ' ',
            !(title === null || title === void 0 ? void 0 : title.content) && tags && tags.length > 0 && (React.createElement(Tags, { tags: tags, marginTop: 0, marginLeft: 5 })))),
        !(title === null || title === void 0 ? void 0 : title.content) && !(subtitle === null || subtitle === void 0 ? void 0 : subtitle.content) && tags && tags.length > 0 && (React.createElement(Tags, { tags: tags, marginTop: 0, marginLeft: 0 }))));
};
export default WidgetHeading;
